import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { catchError, delay, map, of, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ClientPortalService } from '../clientPortalService/client-portal.service';
import { SnackBarService } from '../snackBar-services/snack-bar.service';
export const RCPInterceptor: HttpInterceptorFn = (req, next) => {
  const oAuthService = inject(OAuthService);
  const cpService = inject(ClientPortalService);
  const snackBar = inject(SnackBarService);
  const noExtraHeadersUrl = [
    environment.userConfigUrl + 'userdetails',
    environment.baseUrl + '/inventory/sites',
  ];
  if (req.url.includes(oAuthService.issuer)) {
    return next(req);
  }
  const accessToken = oAuthService.getAccessToken();
  let clonedRequest = req.clone({
    setHeaders: {
      Authorization: accessToken,
    },
  });
  if (!noExtraHeadersUrl.includes(req.url)) {
    clonedRequest = clonedRequest.clone({
      setHeaders: {
        cname: cpService.getActiveClient() || '',
        uuid: cpService.getLoggedInUserInfo()?.UUID || '',
      },
    });
  }
  const warehouseOverride = req.headers.get('x-override-warehouse') === 'true';
  if (!noExtraHeadersUrl.includes(req.url) && !warehouseOverride) {
    clonedRequest = clonedRequest.clone({
      setHeaders: {
        warehouses: cpService.getActiveWarehouses() || '',
      },
    });
  }
  return next(clonedRequest).pipe(
    tap((event) => {
      console.log(event);
    }),
    catchError((e: HttpErrorResponse) => {
      return handleError(e, oAuthService, snackBar, clonedRequest.url);
    })
  );
};
const handleError = (
  error: HttpErrorResponse,
  authService: OAuthService,
  snackBar: SnackBarService,
  reqUrl: string
) => {
  let errorMessage;
  if (error?.error instanceof ErrorEvent || error?.error?.statuscode === 400) {
    // Get client-side error
    errorMessage =
      error?.error?.message ||
      error?.error?.response?.errorMsg ||
      error?.error?.response?.errorMessage ||
      error?.error?.response;
    console.error('A client side error occured ', error);
  } else {
    // Get server-side error
    errorMessage = 'A server side error occured.';
    console.error('A server side error occured ', error);
  }
  if (error?.status === 401) {
    console.log('loggin out because of ' + reqUrl, error);
    snackBar.showError(
      'Session Expired',
      'Your session has expired, please log in again.'
    );
    of(null)
      .pipe(delay(2000))
      .subscribe(() => {
        authService.logOut();
      });
  } else if (error?.status === 403) {
    snackBar.showError(
      'Access Denied',
      'You do not have permission to perform this action.'
    );
  } else {
    snackBar.showError('API Error', errorMessage);
  }
  return throwError(() => {
    return error;
  });
};
export const noContentInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBarservice = inject(SnackBarService);
  return next(req).pipe(
    map((event) => {
      if (event instanceof HttpResponse && event.status === 204) {
        snackBarservice.showError(
          'No data available for selected dates and filters',
          'Please select a different range'
        );
        return event.clone({ body: null });
      }
      return event;
    })
  );
};
export const originInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method === 'GET') {
    const url = new URL(req.url);
    const origin = url.origin; // e.g., "http://localhost:4200" or "https://api.example.com"
    const hostname = url.hostname; // e.g., "localhost" or "api.example.com"
    console.log('Request Origin:', origin);
    console.log('Request Hostname:', hostname);
    const modifiedRequest = req.clone({
      setHeaders: {
        'X-Request-Origin': origin,
      },
    });
    return next(modifiedRequest);
  }
  return next(req); // Pass the original request as Origin cannot be set here
};
